import { render, staticRenderFns } from "./SubBottom.vue?vue&type=template&id=3edc600e"
import script from "./SubBottom.vue?vue&type=script&lang=js"
export * from "./SubBottom.vue?vue&type=script&lang=js"
import style0 from "./SubBottom.vue?vue&type=style&index=0&id=3edc600e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports